import React, { useState, useEffect } from 'react';
import ImageComponent from '../../../../atoms/Image';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const CartNotification = props => {
  const { contentData = [], isModalOpen } = props;
  const { PRICECHANGENOTIFICATION, OUTOFSTOCKNOTIFICATION } = CART_PAGE_CONSTANTS;
  const [showoutofstock, setShowOutofStock] = useState(false);
  const [showpricechange, setShowPriceChange] = useState(0);
  const { Error } = IMAGE_PATH;
  useEffect(() => {
    let unavailable = contentData.filter(item => item.toRemove);
    unavailable && unavailable.length > 0 ? setShowOutofStock(true) : setShowOutofStock(false);
    let priceChanged = contentData.filter(item => item.requireModification);
    priceChanged && priceChanged.length > 0 ? setShowPriceChange(priceChanged.length) : setShowPriceChange(0);
  }, [contentData]);
  return (
    <div data-testid='cart-notification'>
      {showoutofstock && !isModalOpen ? (
        <div className='notify-alert' data-testid='out-of-stock-notify'>
          <ImageComponent srcFile={Error} className='location-alert-icon' />
          {translateWithI18Next(OUTOFSTOCKNOTIFICATION)}
        </div>
      ) : null}
      {showpricechange && !isModalOpen ? (
        <div className='notify-alert' data-testid='price-update-notify'>
          <ImageComponent srcFile={Error} className='location-alert-icon' />
          {`${showpricechange} ${translateWithI18Next(PRICECHANGENOTIFICATION)}`}
        </div>
      ) : null}
    </div>
  );
};

export default CartNotification;
